/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TextInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function TextInput({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/TextInput",
  onChange
  
}) {
let questionAnswerValueData = fromData.useDataFormat({ viewPath,
context: 'question',
path: 'answer',
format: fromHelpers.sanitise,
})
let questionAnswerChangeData = fromData.useDataChange({ viewPath,
context: 'question',
path: 'answer',
})
let questionIsValidValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'isValid',
})
let questionTextTransformValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'textTransform',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let questionAutoFocusValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'autoFocus',
})
let onKeyUp = fromHelpers.useOnKeyUp({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="text"
 marginTop={0}
 width={250}
 flexGrow={0}
 data="question.answer"
 format="helpers.js sanitise"
 value={questionAnswerValueData}
 onChange={questionAnswerChangeData}
 data="question.isValid"
 invalid={!questionIsValidValueData}
 data="question.textTransform"
 textTransform={questionTextTransformValueData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 paddingLeft={dtSpaceXxs}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 placeholder="start typing..."
 data="question.autoFocus"
 autoFocus={questionAutoFocusValueData}
 onKeyUp={onKeyUp}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}